import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const { googleSession } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    (async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      const result = await googleSession(sessionId);
      window.history.replaceState(null, "", window.location.pathname);
      navigate(result.success ? "/dashboard" : "/login", { replace: true });
    })();
  }, [googleSession, navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-3 text-secondary">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="font-semibold">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
